import { Outlet } from "react-router-dom";
import Helmet from "react-helmet";

import { getPageTitle } from "@utils";
import { AddPortfolioLayout } from "@layouts/AddPortfolioLayout/AddPortfolioLayout";

export function AddPortfolio() {
  return (
    <>
      <Helmet>
        <title>{getPageTitle("Add new Portfolio")}</title>
      </Helmet>
      <AddPortfolioLayout>
        <Outlet />
      </AddPortfolioLayout>
    </>
  );
}
